import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './slice/ThemeSlice';
import authReducer from './slice/AuthSlice';


 const Store = configureStore({
    reducer: {
        theme: themeReducer,
        userSlice: authReducer
    },
});

export default Store;
